import { render } from "./LiveSearch.vue?vue&type=template&id=39f24e55&scoped=true"
import script from "./LiveSearch.vue?vue&type=script&lang=js"
export * from "./LiveSearch.vue?vue&type=script&lang=js"

import "./LiveSearch.vue?vue&type=style&index=0&id=39f24e55&scoped=true&lang=scss"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f24e55"]])

export default __exports__